function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12.36 5.5L3.61.252a1.75 1.75 0 00-2.65 1.5v10.5a1.75 1.75 0 002.651 1.5L12.36 8.5a1.75 1.75 0 000-3z"
});

function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNCAxNCI+CiAgICA8cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTEyLjM2IDUuNUwzLjYxLjI1MkMzLjA3LS4wNzMgMi4zOTYtLjA4MSAxLjg0Ny4yMjkgMS4yOTguNTQuOTYgMS4xMjEuOTYgMS43NTJ2MTAuNWMwIC42My4zNCAxLjIxMi44ODggMS41MjMuNTQ5LjMxIDEuMjIyLjMwMiAxLjc2My0uMDIzTDEyLjM2IDguNWMuNTI3LS4zMTYuODQ5LS44ODYuODQ5LTEuNXMtLjMyMi0xLjE4NC0uODQ5LTEuNXoiLz4KPC9zdmc+Cg==";
export { SvgPlay as ReactComponent };